
export class AgentRequestACallModel {
  applicationId: number;
  bestContactMumber: string | undefined;
  note: string | undefined;
  bestCallbackTime: string;

  constructor(appId: number) {
    this.applicationId = appId;
    const now = new Date();
    this.bestCallbackTime = new Date(now.getTime() - now.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
  }
}
